webpackJsonp([239381677830736],{

/***/ 770:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNENBRjUwIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styleHelpers = __webpack_require__(9);
	
	var _check = __webpack_require__(770);
	
	var _check2 = _interopRequireDefault(_check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'e8n88bt0'
	})('display:inline-block;margin:0;text-align:left;');
	
	var ListItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'e8n88bt1'
	})('font-size:20px;list-style:none;margin:0 0 25px 34px;text-transform:uppercase;&:before{background:url(', _check2.default, ') no-repeat;content:"";display:inline-block;height:24px;margin:0 10px 0 -34px;width:24px;}p{display:inline-block;}&:before,p{line-height:24px;vertical-align:top;}');
	
	var Checklist = function Checklist(_ref) {
	  var checklist = _ref.checklist;
	  return _react2.default.createElement(
	    List,
	    null,
	    checklist.map(function (item, index) {
	      return _react2.default.createElement(
	        ListItem,
	        { key: index },
	        _react2.default.createElement(
	          'p',
	          null,
	          item
	        )
	      );
	    })
	  );
	};
	
	Checklist.propTypes = {
	  checklist: _propTypes2.default.array.isRequired
	};
	
	exports.default = Checklist;
	module.exports = exports['default'];

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styleHelpers = __webpack_require__(9);
	
	var _Wrapper = __webpack_require__(24);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _Background = __webpack_require__(206);
	
	var _Checklist = __webpack_require__(330);
	
	var _Checklist2 = _interopRequireDefault(_Checklist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ewpx8qp0'
	})('color:#616161;overflow:hidden;padding:65px 0;position:relative;');
	
	var StyledBackgroundContainer = /*#__PURE__*/(0, _reactEmotion2.default)(_Background.BackgroundContainer, {
	  target: 'ewpx8qp1'
	})('.gatsby-image-outer-wrapper:after{background:rgba(255,255,255,0.85);bottom:0;content:"";display:block;left:0;position:absolute;right:0;top:0;}');
	
	var List = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ewpx8qp2'
	})('margin-top:20px;text-align:center;width:100%;', _styleHelpers.mediumMediaQuery, '{max-width:540px;text-align:left;width:auto;}');
	
	var ContentWrapper = /*#__PURE__*/(0, _reactEmotion2.default)(_Wrapper2.default, {
	  target: 'ewpx8qp3'
	})('align-items:center;display:flex;flex-flow:row wrap;justify-content:center;max-width:973px;min-height:225px;position:relative;z-index:1;&.direction-r{flex-direction:row-reverse;', _styleHelpers.mediumMediaQuery, '{', List, '{margin:0 0 0 40px;}}}', _styleHelpers.mediumMediaQuery, '{flex-wrap:nowrap;justify-content:space-between;', List, '{margin:0 40px 0 0;}}');
	
	var Title = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
	  target: 'ewpx8qp4'
	})('color:#4caf50;font-size:32px;margin:0 0 25px 0;text-transform:uppercase;');
	
	var Quote = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ewpx8qp5'
	})('margin-top:20px;text-align:center;width:100%;', _styleHelpers.mediumMediaQuery, '{margin-top:0;max-width:345px;text-align:left;width:auto;}');
	
	var QuoteContent = /*#__PURE__*/(0, _reactEmotion2.default)('q', {
	  target: 'ewpx8qp6'
	})('color:#2c2c2c;display:block;font-size:32px;font-style:italic;font-weight:700;letter-spacing:0.18px;line-height:1.2;margin:0 0 16px 0;quotes:"\u201C" "\u201D";&:before{content:open-quote;}&:after{content:close-quote;}');
	
	var Citation = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'ewpx8qp7'
	})((0, _styleHelpers.heavyFontFamily)(), '\n  font-size:18px;letter-spacing:2.8px;line-height:1.2;margin:0;text-transform:uppercase;');
	
	var Benefit = function Benefit(_ref) {
	  var className = _ref.className,
	      background = _ref.background,
	      title = _ref.title,
	      checklist = _ref.checklist,
	      quote = _ref.quote;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      StyledBackgroundContainer,
	      null,
	      _react2.default.createElement(_Background.BackgroundImage, { sizes: background.childImageSharp.sizes })
	    ),
	    _react2.default.createElement(
	      ContentWrapper,
	      { className: className },
	      _react2.default.createElement(
	        List,
	        null,
	        _react2.default.createElement(
	          Title,
	          null,
	          title
	        ),
	        _react2.default.createElement(_Checklist2.default, { checklist: checklist })
	      ),
	      _react2.default.createElement(
	        Quote,
	        null,
	        _react2.default.createElement(
	          QuoteContent,
	          null,
	          quote.content
	        ),
	        _react2.default.createElement(
	          Citation,
	          null,
	          '\u2014 ',
	          quote.citation
	        )
	      )
	    )
	  );
	};
	
	Benefit.propTypes = {
	  background: _propTypes2.default.object.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  checklist: _propTypes2.default.array.isRequired,
	  quote: _propTypes2.default.object.isRequired
	};
	
	exports.default = Benefit;
	module.exports = exports['default'];

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Benefit = __webpack_require__(331);
	
	var _Benefit2 = _interopRequireDefault(_Benefit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Benefits = function Benefits(_ref) {
	  var benefits = _ref.benefits;
	  return _react2.default.createElement(
	    'div',
	    null,
	    benefits.edges.map(function (benefit, index) {
	      return _react2.default.createElement(_Benefit2.default, _extends({ key: index, className: 'direction-' + (index % 2 ? 'r' : 'l') }, benefit.node));
	    })
	  );
	};
	
	Benefits.propTypes = {
	  benefits: _propTypes2.default.object.isRequired
	};
	
	exports.default = Benefits;
	module.exports = exports['default'];

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Page = __webpack_require__(45);
	
	var _Hero = __webpack_require__(29);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Wrapper = __webpack_require__(24);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _Benefits = __webpack_require__(332);
	
	var _Benefits2 = _interopRequireDefault(_Benefits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WhyChouxboxPage = function WhyChouxboxPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Page.PageContainer,
	    null,
	    _react2.default.createElement(_Page.PageHelmet, { name: 'whyChouxbox' }),
	    _react2.default.createElement(_Hero2.default, { heroImage: data.heroImage, title: 'Why Chouxbox?' }),
	    _react2.default.createElement(_Benefits2.default, { benefits: data.benefits })
	  );
	};
	
	exports.default = WhyChouxboxPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-chouxbox-js-39e007a6feaffd1ca021.js